var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupports({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C8.13401 2 5 5.13401 5 9V13C5 13.5523 4.44772 14 4 14C3.44772 14 3 13.5523 3 13V9C3 4.02944 7.02944 0 12 0C16.9706 0 21 4.02944 21 9V13C21 13.5523 20.5523 14 20 14C19.4477 14 19 13.5523 19 13V9C19 5.13401 15.866 2 12 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10C2.89543 10 2 10.8954 2 12V16C2 17.1046 2.89543 18 4 18C5.10457 18 6 17.1046 6 16V12C6 10.8954 5.10457 10 4 10Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C18.8954 10 18 10.8954 18 12V16C18 17.1046 18.8954 18 20 18C21.1046 18 22 17.1046 22 16V12C22 10.8954 21.1046 10 20 10Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14V12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12V14Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15C12 15 10.5 16 8.5 17C7.67157 17 7 17.6716 7 18.5C7 19.3284 7.67157 20 8.5 20H9.5C10.3284 20 11 19.3284 11 18.5V17.5L12 15Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18C16.6569 18 18 16.6569 18 15V14C18 12.3431 16.6569 11 15 11H13C12.4477 11 12 11.4477 12 12C12 12.5523 12.4477 13 13 13H15C15.5523 13 16 13.4477 16 14V15C16 15.5523 15.5523 16 15 16H14.5L13.5 17L14.5 18H15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupports);
export default __webpack_public_path__ + "static/media/supports.510b60a7d7b2992bbe077a208e5e257e.svg";
export { ForwardRef as ReactComponent };